import { fuelMap } from '~src/constants/fuel';
import {
  APARTMENT_TAKEOVER_SUBTEXT,
  APARTMENT_TAKEOVER_TEXT,
  HIGH_USAGE_TAKEOVER_SUBTEXT,
  HIGH_USAGE_TAKEOVER_TEXT,
  INVALID_HEATING_SUBTEXT,
  INVALID_HEATING_TEXT,
} from '~src/constants/takeover';
import { TakeoverType } from '~src/model';

type InformationStageMap = Record<'residenceInformation' | 'consumptionInformation', number>;

const BodilStages = (mobile: boolean): InformationStageMap =>
  mobile
    ? {
        residenceInformation: 1,
        consumptionInformation: 3,
      }
    : {
        residenceInformation: 3,
        consumptionInformation: 5,
      };

const NorlysStages = (mobile: boolean): InformationStageMap =>
  mobile
    ? {
        residenceInformation: 0,
        consumptionInformation: 2,
      }
    : {
        residenceInformation: 2,
        consumptionInformation: 4,
      };

export const getTakeoverInfo = (
  takeover: TakeoverType,
  fuelType: string,
  isMobile: boolean,
  origin: 'bodil' | 'norlys' = 'bodil'
) => {
  const heating = fuelMap[fuelType];
  const stages = origin === 'bodil' ? BodilStages(isMobile) : NorlysStages(isMobile);

  switch (takeover) {
    case 'apartment': {
      return {
        heading: 'Din bolig er en lejlighed',
        text: APARTMENT_TAKEOVER_TEXT,
        subtext: APARTMENT_TAKEOVER_SUBTEXT,
        button: { text: 'Gå til boligdata', stage: stages['residenceInformation'] },
      };
    }

    case 'highUsage': {
      return {
        heading: 'Højt energi forbrug',
        text: HIGH_USAGE_TAKEOVER_TEXT(true),
        subtext: HIGH_USAGE_TAKEOVER_SUBTEXT,
        button: { text: 'Gå til forbrugsdata', stage: stages['consumptionInformation'] },
      };
    }

    case 'invalidHeating': {
      return {
        heading: `Din bolig opvarmes med ${heating}`,
        text: INVALID_HEATING_TEXT(heating),
        subtext: INVALID_HEATING_SUBTEXT(heating),
        button: { text: 'Gå til forbrugsdata', stage: stages['consumptionInformation'] },
      };
    }
  }
};
